module.exports = __webpack_public_path__ + "static/img/408.9f1efd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/408.png
// module id = 527
// module chunks = 3